module.exports = __webpack_public_path__ + "static/poa-92c48a51b1b66ad7ea93da315cf87210.png";